import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { post } from 'api/requests';

import {
  Answer,
  PostGaranteeLetterType,
  Req,
} from 'features/EngineeringNetStatus/EngineeringInfo/GuaranteeLetter/types';

export const postGaranteeLetter = createAsyncThunk(
  'EN_guaranteeLetter/postGaranteeLetter',
  async (letterFormData: PostGaranteeLetterType, thinkApi) => {
    try {
      const { data } = await post<Req, AxiosResponse<Answer>>(
        '/api/standards/engineering_networks/guarantee-letter/',
        letterFormData,
      );

      return data;
    } catch (error) {
      return thinkApi.rejectWithValue(error);
    }
  },
);
